module.exports = __webpack_public_path__ + "img/icon_ccm.162dece2.svg";